import { createElement, FC, useContext } from 'react';
import { RouteComponentProps } from 'react-router';

import { context as DependencyContext } from '../context/dependency';
import { context as StateContext } from '../context/state';
import Page from '../page/ShowAdAnalyticsReportListPage';

type Props = RouteComponentProps;

const AdAnalyticsReportListPage: FC<Props> = () => {
  const state = useContext(StateContext);
  const dependency = useContext(DependencyContext);

  return (
    <Page
      loading={state.adAnalyticsReports.fetching >= 1}
      analyticsReports={state.adAnalyticsReports.items}
      onGotoReportDetailPage={(id: string) => {
        dependency.listAdAnalyticsReportUsecase.goReportDetailPage(id);
      }}
      deleteReport={(id: string) => {
        dependency.listAdAnalyticsReportUsecase.deleteReport(id);
      }}
      onGotoAnalyticsListPage={() => {
        dependency.listAdAnalyticsReportUsecase.goAnalyticsListPage();
      }}
      onMount={() => {
        dependency.authenticationUsecase.needSignedIn();
        dependency.listAdAnalyticsReportUsecase.prepare();
      }}
      onUnmount={() => {
        dependency.listAdAnalyticsReportUsecase.dispose();
      }}
    />
  );
};

export default AdAnalyticsReportListPage;
